import { createRouter, createWebHistory } from "vue-router";
import store from "@/store";
import HomePage from "@/components/HomePage.vue";
import DetectorPage from "@/components/DetectorPage.vue";
import LogoutPage from "@/components/LogoutPage.vue";
import AdminPage from "@/components/AdminPage.vue";

const router = createRouter({
    history: createWebHistory(),
    routes: [
        {
            path: "/",
            component: HomePage,
            name: "Home",
            meta: { requiresAuth: true }
        },
        {
            path: "/admin",
            component: AdminPage,
            name: "Admin",
            meta: {
                requiresAuth: true,
                requiresAdmin: true
            }
        },
        {
            path: "/deviceinfo/:deviceId",
            name: "DeviceInfo",
            component: DetectorPage,
            meta: { public: true }
        },
        {
            path: "/logout",
            name: "Logout",
            component: LogoutPage,
        },
    ]
});

router.beforeEach(async (to) => {

    const isPublic = to.matched.some(r => r.meta && r.meta.public);

    if (isPublic) {
        return true;
    }


    if (!store.getters.isAuthenticated) {
        await store.dispatch("initAuth");
    }

    if (to.matched.some(record => record.meta.requiresAdmin) && !store.getters.isAdmin) {
        return {name: 'Home'};
    }

    if (to.matched.some(record => record.meta.requiresAuth) && !store.getters.isAuthenticated) {
        await store.dispatch("login");
        return false;
    }

    return true;
});

export default router;